export default "data:font/ttf;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiRm9udEF3ZXNvbWU2X0JyYW5kcy50dGYiOw=="